import { useEffect, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import useKioskCategory from "./useKioskCategory";

const useKioskProduct = () => {
  const history = useHistory();
  const { id, categoryId, productId } =
    useParams<{ id: string; categoryId: string; productId: string }>();
  const { data } = useKioskCategory(id, categoryId);
  useEffect(() => {
    if (
      data?.children &&
      data?.children?.length !== 0 &&
      productId !== undefined
    ) {
      const isFound =
        data?.sub_content?.find(
          (product) => product.item_id === parseInt(productId)
        ) !== undefined;
      if (!isFound) {
        history.goBack();
      }
    }
  }, [productId, data]);

  return useMemo(
    () =>
      data?.sub_content?.find(
        (product) => product.item_id === parseInt(productId)
      ),
    [productId, data]
  );
};

export default useKioskProduct;
